module.exports = __webpack_public_path__ + "img/cancel-gray.5ca1d3ac.svg";